import './styles/style.scss'
import energoLogo from './energoLogo.svg';
import { useParams } from "react-router-dom";
import { ManagersIdsMap } from './ManagersMap';

const WA = 'https://wa.me/';
const TG = 'https://t.me/';

export default function ManagersIds() {
  const { id } = useParams();
  const managerInfos = ManagersIdsMap[id] || undefined;

  const downloadVCard = () => {
    const vcardContent = `BEGIN:VCARD
VERSION:3.0
N:${managerInfos?.name};${managerInfos?.secName}
FN:${managerInfos?.name} ${managerInfos?.secName}
TEL;cell:${managerInfos?.phone}
EMAIL;TYPE=INTERNET:${managerInfos?.email}
END:VCARD`;

    const blob = new Blob([vcardContent], { type: 'text/vcard' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${id}.vcf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const onWatsapp = () => {
    const link = document.createElement('a');
    link.href = `${WA}${managerInfos?.watsapp}`;
    link.click();
    document.body.removeChild(link);
  };

  const onTelegram = () => {
    const link = document.createElement('a');
    link.href = `${TG}${managerInfos?.telegram}`;
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className='mn-card'>
      {
        managerInfos ?
          <div className='mn-all-card'>
            <div className="mn-card-container">
              <img className="mn-card-logo" src={energoLogo} alt='energo' />
              <div className="mn-card-info">
                <div className="mn-card-name">
                  {managerInfos?.name}
                </div>
                <div className="mn-card-second-name">
                  {managerInfos?.secName}
                </div>
                <div className="mn-card-pos">
                  {managerInfos?.position}
                </div>
              </div>
              <div className='mn-card-divider' />
              <div className="mn-card-contacts">
                <div className='mn-card-contact-item'>
                  <div className="mn-card-contacts-title">
                    телефон
                  </div>
                  <div className="mn-card-contacts-content">
                    {managerInfos?.phone}
                  </div>
                </div>
                <div className='mn-card-contact-item'>
                  <div className="mn-card-contacts-title">
                    эл.почта
                  </div>
                  <div className="mn-card-contacts-content">
                    {managerInfos?.email}
                  </div>
                </div>
              </div>
              <div className='mn-card-divider' />
              <div className='mn-card-buttons'>
                <div className='mn-card-buttons-soc'>
                  <div onClick={onTelegram} className='mn-card-button'>Telegram</div>
                  <div onClick={onWatsapp} className='mn-card-button'>WhatsApp</div>
                </div>
                <div onClick={downloadVCard} className='mn-card-button long-button'>Добавить контакт в телефон</div>
              </div>
            </div>
          </div>
          :
          <div className="mn-card-container">
            <div className="mn-card-name">
              Такой визитки не существует
            </div>
          </div>
      }
    </div>
  );
}
